import ExecuteInboxRulesRequest from 'owa-service/lib/contract/ExecuteInboxRulesRequest';
import ExecuteInboxRulesJsonRequest from 'owa-service/lib/contract/ExecuteInboxRulesJsonRequest';
import ExecuteInboxRulesJsonResponse from 'owa-service/lib/contract/ExecuteInboxRulesJsonResponse';
import executeInboxRulesOperation from 'owa-service/lib/operation/executeInboxRulesOperation';
import executeInboxRulesRequest from 'owa-service/lib/factory/executeInboxRulesRequest';
import folderIdFactory from 'owa-service/lib/factory/folderId';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
import { RuleBulkActionCustomData } from '../orchestrators/runRuleNowOrchestrator';

/**
 * Execute inbox rules service
 * @param ruleId the rule to run
 * @param sourceFolderId the source folderId
 * @param customData custom data to use in the bulk action manager
 * @return the ExecuteInboxRulesResponse
 */
export default function executeInboxRulesService(
    ruleId: string,
    sourceFolderId: string,
    customData?: RuleBulkActionCustomData
): Promise<ExecuteInboxRulesJsonResponse> {
    const requestBody = executeInboxRulesRequest(<ExecuteInboxRulesRequest>{
        InboxRuleIds: [ruleId],
        SourceFolderId: folderIdFactory({ Id: sourceFolderId }),
        BulkActionRequest: true,
        BulkActionCustomData: JSON.stringify(customData),
    });

    return executeInboxRulesOperation(<ExecuteInboxRulesJsonRequest>{
        Header: getJsonRequestHeader(),
        Body: requestBody,
    });
}
